import config from '@/config/api-config';
import axiosConfig from './axios.service';
import { setAuthToken } from "@/utils/storage";

// Create a company
export const createCompany = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/company-info`, data);
    setAuthToken(response.data.accessToken);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const companyMeta = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/company-meta-info`, data);
    setAuthToken(response.data.accessToken);
    return response.data;
  } catch (error) {
    return error;
  }
}


export const companyContact = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/company-contact-info`, data);
    setAuthToken(response.data.accessToken);
    return response.data;
  } catch (error) {
    return error;
  }
}
export const companyAddress = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/address`, data);
    setAuthToken(response.data.accessToken);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const getSector = async (params) => {
  try {
    const { sector = '', limit = 10, page = 1 } = params;
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/sectors`, {
      params: {
        sector,
        limit,
        page
      }
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getCompanySize = async (params) => {
  try {
    // Destructure the params object
    const { size = '', limit = 10, page = 1 } = params;

    const response = await axiosConfig.get(`${config.API_ROOT_HR}/company-size`, {
      params: {
        size,
        limit,
        page
      }
    });
    return response.data;
  } catch (error) {
    return error;
  }
};


// Submit company address
export const submitCompanyAddress = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/address`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};

// Update HR contact info
export const updateHrContactInfo = async (data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/user-data`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const createTodoList = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/todolist`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const getTodoList = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/todolist`);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const deleteTodoList = async (id) => {
  try {
    const response = await axiosConfig.delete(`${config.API_ROOT_HR}/todolist/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const updateTodoList = async (id, data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/todolist/${id}`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const getCollegeList = async (params = {}, searchValue = '', next = '', status = '') => {  
  console.log('searchValue: ', searchValue);
  try {
    const requestParams = {
      ...params,
      next,
      search: searchValue, // Add search as a parameter
      connectionType: status
    };

    const response = await axiosConfig.get(`${config.API_ROOT_HR}/college-listing`, {
      params: requestParams
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching college list:', error);
    throw error;
  }
};

export const getCollegeDetails = async (id) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/college-info/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}
export const getCollegeConnectionStatus = async (params = {}) =>{
  try{
      const response = await axiosConfig.get(`${config.API_ROOT_HR}/college-connection-listing`, {
          params
      });
      return response.data;
  }
  catch (error) {
      return error;
  }

}

export const getCollegeTopSkill = async (id) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/department-top-skill/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const companyProfil = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/company-dashboard-info`);
    return response.data;
  } catch (error) {
    return error;
  }
}
export const createInfrastructure = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/company-infrastructure`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    return error;
  }
}
export const updateInfrastructure = async (id, data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/company-infrastructure/${id}`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }
    );
    return response.data;
  } catch (error) {
    return error;
  }
}


export const deleteInfrastructure = async (id) => {
  try {
    const response = await axiosConfig.delete(`${config.API_ROOT_HR}/company-infrastructure/${id}`);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const editCompanyInfo = async (data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/company-dashboard-info`, data)
    return response.data;
  } catch (error) {
    return error;
  }
}
export const updateProfilePic = async (data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/company-profile`, data, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  } catch (error) {
    return error;
  }
}
export const deleteProfilePic = async () => {
  try {
    const response = await axiosConfig.delete(`${config.API_ROOT_HR}/company-profile`);
    return response.data;
  } catch (error) {
    return error;
  }
}
export const getHRAccountDetails = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/account-settings`);
    return response.data;
  }
  catch (error) {
    return error;
  }
}

export const updateHRAccountDetails = async (data) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/account-settings`, data);
    return response.data;
  }
  catch (error) {
    return error;
  }
}
export const changeHRPassword = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.AUTH_API_ROOT_HR}/change-password`, data);
    return response.data;
  }
  catch (error) {
    return error;
  }
}
export const getHRAddress = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/address`);
    return response.data;
  } catch (error) {
    return error;
  }
}

export const submitHRAddress = async (data, addressId) => {
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/address/${addressId}`, data);
    return response.data;
  } catch (error) {
    return error;
  }
};
export const getHRSecurity = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/security`);
    return response.data;
  }
  catch (error) {
    return error;
  }
}
export const HRtwoStepVerificationOTPSent = async () => {
  try {
    const response = await axiosConfig.post(`${config.AUTH_API_ROOT_HR}/two-step-verification`);
    return response.data;
  }
  catch (error) {
    return error;
  }
}
export const HRverifyTwoStepVerification = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.AUTH_API_ROOT_HR}/two-step-verify-otp`, data);
    return response.data;
  }
  catch (error) {
    return error;
  }
}


export const HRConnect = async (id,status) => {
  // console.log('data: sssss', data);
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/connect-po`,{
      collegeId: id,
      status: status
  },{
      headers: {
          // "show-toast": "false",
          "show-loader": "false",
      }
  });
    return response.data
  }
  catch (error) {
    return error;
  }
}

export const ConnectedCollegeList = async (params = {}, searchValue = '', status = '') => {
  try {
    // Set accepted as string "accepted"
    const defaultParams = {
      status: status,
      ...params,
      search: searchValue,

    };

    const response = await axiosConfig.get(`${config.API_ROOT_HR}/connection-status`, {
      params: defaultParams,
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getCllegeByStatus = async (params = {})=>{
  try{
      const response = await axiosConfig.get(`${config.API_ROOT_HR}/connection-status`, {
          params
      });
      return response.data;
  }
  catch (error) {
      return error;
  }
}

export const getTotalConnectionCount = async (data) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/connection-status-count`, data);
    return response.data
  }
  catch (error) {
    return error;
  }
}

export const getLocationSort = async (data) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/location`, {
      params: { city: data.city },
    });
    return response.data;
  } catch (error) {
    return error;
  }
};

export const getSkillSort = async (data) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/student-skills`, {
      params: { skills: data.skill }
    });
    return response.data;
  } catch (error) {
    return error;
  }
};


export const HRAcceptConnect = async (id,status) => {
  // console.log('data: ', data);
  try {
    const response = await axiosConfig.put(`${config.API_ROOT_HR}/connection-approval/${id}`, {
      status: status
    }, {
      headers: {
        "show-toast": "false"
      }
    });
    return response
  }
  catch (error) {
    return error;
  }
}

export const getHRInfo = async () => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/user-info`);
    return response.data.data;
  } catch (error) {
    return error;
  }
};

export const getSectors = async (data, cursor) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/sectors`, {
      params: {
        search: data,
        cursor: cursor
      }
    });
    return response.data;
  }
  catch (error) {
    return error;
  }
}

export const getCompanySizeFilter = async (data, cursor) => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/company-size`, {
      params: {
        search: data,
        cursor: cursor
      }
    });
    return response.data;
  }
  catch (error) {
    return error;
  }
}

export const getServiceData = async (service = '', next = '') => {
  try {
    const response = await axiosConfig.get(`${config.API_ROOT_HR}/company-service`, {
      params: {
        service, next
      }
    });
    return response.data;
  }
  catch (error) {
    return error;
  }
}



export const sentFAQ = async (data) => {
  try {
    const response = await axiosConfig.post(`${config.API_ROOT_HR}/faq`, data);
    return response.data;
  } catch (error) {
    return error;
  }
}